module.exports = __webpack_public_path__ + "static/media/hammer3.cee82e83.png";